import React, { useState } from 'react'
import type { Book } from '@/types'
import './ConversationRequestModal.css'

type ConversationType = 'borrow' | 'comment'

interface ConversationRequestModalProps {
    isOpen: boolean
    onClose: () => void
    onSubmit: (message: string, type: ConversationType, books: Book[]) => void
    title: string
    books: Book[]
    type: ConversationType
    submitting: boolean
}

export default function ConversationRequestModal({
    isOpen,
    onClose,
    onSubmit,
    title,
    books,
    type,
    submitting,
}: Readonly<ConversationRequestModalProps>) {
    const [message, setMessage] = useState('')

    if (!isOpen) return null

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (!message.trim()) return
        onSubmit(message, type, books)
    }

    return (
        <div className="modal-overlay animate-fade-in" onClick={onClose}>
            <div className="modal-content conversation-request-modal animate-fade-in-up" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{title}</h3>
                    <button className="close-btn" onClick={onClose}>
                        ×
                    </button>
                </div>

                <div className="modal-body">
                    <div className="books-summary">
                        <p>
                            Has seleccionado <strong>{books.length}</strong> {books.length === 1 ? 'libro' : 'libros'}:
                        </p>
                        <ul className="books-list-preview">
                            {books.slice(0, 5).map((book) => (
                                <li key={book.id}>
                                    {book.title} ({Array.isArray(book.author) ? book.author.join(', ') : book.author})
                                </li>
                            ))}
                            {books.length > 5 && <li className="more-books">...y {books.length - 5} más</li>}
                        </ul>
                    </div>

                    <form id="msg-form" onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="message-text">Mensaje:</label>
                            <textarea
                                id="message-text"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder={
                                    type === 'borrow'
                                        ? 'Hola, me gustaría pedir prestados estos libros...'
                                        : 'Hola, quería comentarte sobre estos libros...'
                                }
                                required
                                rows={4}
                                maxLength={1000}
                            />
                            <div className="char-count">
                                {message.length}/1000
                            </div>
                        </div>
                    </form>
                </div>

                <div className="modal-footer">
                    <button className="btn-secondary" onClick={onClose} disabled={submitting}>
                        Cancel
                    </button>
                    <button form="msg-form" type="submit" className="btn-primary" disabled={submitting || !message.trim()}>
                        {submitting ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>
        </div>
    )
}
